export const enum DefaultCountry {
    USA = "USA",
    Canada = "Canada"
}

export const enum DefaultCustodyType {
    Rent = "rent",
    Own = "own",
    Lease = "lease"
}

export const enum DefaultDataSource {
    GDWOnly = "GDWOnly",
    GDWWithAI = "GDWWithAI"
}

export type ChatSettings = {
    detailedResponses: boolean;
    country: string;
    custodyType: string;
    dataSource: string;
};

export type ResponseMessage = {
    content: string;
    role: string;
    createdAt: string;
    /** "incomplete" when the answer was cut short and is partial. */
    status?: string;
};

export type ResponseContext = {
    thoughts: string | null;
    data_points: string[];
    followup_questions: string[] | null;
};

export type FileReference = {
    fileId: string;
    containerId?: string;
    filename?: string;
    mimeType?: string;
    content?: string;
};

export type ResponseChoice = {
    index: number;
    message?: ResponseMessage;
    functionName?: string;
    functionArguments?: string;
    functionResult?: string;
    functionFallback?: string;
    functionCalledAt?: string;
    files?: FileReference[];
    reasoningText?: string;
    context: ResponseContext;
    session_state: any;
};

export type ResponseError = {
    status?: string;
    type?: number;
    title?: string;
    detail?: string;
};

export type ChatAppResponse = {
    chatId: string;
    inputTokens: number;
    outputTokens: number;
    totalTokens: number;
    instruction: string;
    isCompleted: boolean;
    gptError?: string;
    gptErrorTime?: string;
    choices: ResponseChoice[];
};

export type ChatAppRequest = {
    messages: ResponseMessage[];
    stream?: boolean;
    session_state?: any;
};

export type ChatHistoryItem = {
    chatId: string;
    title: string;
    createdAt: string;
    lastMessageAt: string;
};

export type UserLogin = {
    isFailed: boolean;
    message: string;
    userEmail: string;
    token: string;
    userProfile: {
        id: number;
        email: string;
        azureUserId: string;
        status: string;
        authMethod: string;
        lastLogin: string;
    };
    linkedAccounts?: {
        id: string;
        provider: string;
        displayName: string;
        email: string;
        linkedAt: string;
    }[];
};
